import React from 'react'
import { Line, Pattern, Rect } from 'react-native-svg'

/**
 * Heavy fog of war fill: the fog grey with tight, single-direction diagonal
 * lines (docs/fog-of-war/README.md). Used AS the fill of a territory or disc,
 * never as an overlay, so each shape's own border is painted on top of it and
 * the lines never cross territory or region lines.
 *
 * Patterns are scoped to the <Svg> that defines them on native, so every layer
 * that draws fog (the board, and the marker-disc overlay) defines it with this
 * one component and the two can't drift apart.
 */
export function FogHatchPattern({ id, gap, background, color }: { id: string; gap: number; background: string; color: string }) {
  return (
    <Pattern id={id} patternUnits="userSpaceOnUse" width={gap} height={gap} patternTransform="rotate(45)">
      <Rect x={0} y={0} width={gap} height={gap} fill={background} />
      <Line x1={0} y1={0} x2={0} y2={gap} stroke={color} strokeWidth={gap * 0.35} />
    </Pattern>
  )
}
